import React from 'react';
import {Alert} from 'react-bootstrap';
import { useCheckIn } from '../../hooks/useCheckIn';

const ThankYouOverlay: React.FC = () => {
  const { state } = useCheckIn();

  if (!state.showThankYou) {
    return null;
  }

  return (
    <Alert variant="success" className="text-center" style={{ position: 'absolute', right: '2rem', top: '1.75rem'}}>{state.thankYouMessage}</Alert>
  );
};

export default ThankYouOverlay;